import React from "react";
import styled from "styled-components";
import { Coffee } from "lucide-react";

const InfoPage = () => {
  return (
    <Container>
      <Subtitle>Your Ultimate OSRS Slayer Companion</Subtitle>

      <Description>
        SlayerScape is a user-friendly tool designed to assist Old School
        RuneScape players in tackling their slayer tasks. It offers up-to-date
        information and resources to guide players in efficiently completing
        their next assignment. Data is mined from the OSRS Wiki to avoid
        out-of-date info.
      </Description>

      <DonationSection>
        <Description>
          Developed with love, donations are much appreciated to keep the
          project going!
        </Description>

        <CoffeeButton
          onClick={() =>
            window.open("https://buymeacoffee.com/slayerscape", "_blank")
          }
        >
          <Coffee size={24} />
          Buy me a coffee
        </CoffeeButton>
      </DonationSection>
    </Container>
  );
};

export default InfoPage;

const Container = styled.div`
  padding: 1rem;
  text-align: center;
`;

const Title = styled.h1`
  font-size: 2.5rem;
  font-weight: bold;
  margin-bottom: 0.5rem;
`;

const Subtitle = styled.p`
  font-size: 1.2rem;
`;

const Description = styled.p`
  line-height: 1.6;
  margin-bottom: 2rem;
`;

const DataSourceBox = styled.div`
  background: #f8f9fa;
  border-radius: 8px;
  padding: 1rem;
  margin-bottom: 2rem;
`;

const DonationSection = styled.div`
  text-align: center;
  margin-top: 2rem;
`;

const CoffeeButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  background-color: #ffcc00;
  color: #333;
  padding: 0.75rem 1.5rem;
  border-radius: 8px;
  font-weight: 500;
  border: none;
  cursor: pointer;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: #ffff00;
  }
`;
